
import { Component, mixins } from 'nuxt-property-decorator';
import SanityBlockContentMixin from '~/mixins/SanityBlockContent';

@Component
export default class SanityBlockContent extends mixins(
  SanityBlockContentMixin,
) {}
